<script setup lang="ts">
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';

import { webAuth } from '../../auth/web-auth.js';

// `/login`: vai direto ao portal central, voltando ao callback deste app.
const route = useRoute();
onMounted(() => window.location.assign(webAuth().loginUrl(route.query.returnTo)));
</script>

<template>
  <main aria-hidden="true" />
</template>
